import React, { useState, memo } from 'react';
import classNames from 'classnames';
import { ENTER_KEYDOWN } from '../../constants/keydown';
import makeBodyText from '../../utils/makeText';
import styles from './index.module.scss';
const Item = memo(({ label, description }, index) => {
    const [isOpen, setOpenState] = useState(false);
    const handleClick = () => setOpenState(!isOpen);
    const handleKeyDown = (e) => e.keyCode === ENTER_KEYDOWN && handleClick();
    const classes = classNames({
        [styles.accordionWrap]: true,
        [styles.open]: isOpen
    });
    return (React.createElement("div", { key: `${label}_${index}`, className: classes, tabIndex: 0, role: 'button', "aria-label": `Accordion ${isOpen ? 'open' : 'closed'}`, onKeyDown: handleKeyDown, onClick: handleClick },
        React.createElement("div", { className: styles.icon }),
        React.createElement("div", { className: styles.description },
            React.createElement("h3", { className: `${styles.label} ${makeBodyText('XL')}` },
                React.createElement("strong", null, label)),
            React.createElement("p", { className: `${styles.text} ${makeBodyText('L')}` }, description))));
});
Item.displayName = 'AccordionItem';
export default Item;
